export const determineCareType = careTypes => {
  if (careTypes.length > 1) {
    if (careTypes.includes("liveincareanytime")) return "liveincareanytime";
    if (careTypes.includes("liveincareoccasionalonly"))
      return "liveincareoccasionalonly";
    if (careTypes.includes("liveincareweekendsonly"))
      return "liveincareweekendsonly";
    if (careTypes.includes("dayshifts")) return "dayshifts";

    if (careTypes.includes("nightshifts")) return "nightshifts";
  }

  return careTypes[0] || null;
};

export const ensureLanguageIsFirst = (languages, language) => {
  if (!languages.includes(language) || languages[0] === language) {
    return languages;
  }

  const removedLanguage = languages.filter(lang => lang !== language);
  removedLanguage.unshift(language);

  return removedLanguage;
};

export const determineAdditionalArray = profileData => {
  const additionalArray = [];
  if (profileData.driving_license) {
    additionalArray.push("Licensed driver");
  }

  if (profileData.car) {
    additionalArray.push("Car owner");
  }

  if (profileData.smoker === false) {
    additionalArray.push("Non smoker");
  }

  return additionalArray;
};

export const chunk = (array, size) => {
  let index = 0;
  const arrayLength = array.length;
  const tempArray = [];

  for (index = 0; index < arrayLength; index += size) {
    const myChunk = array.slice(index, index + size);
    // Do something if you want with the group
    tempArray.push(myChunk);
  }

  return tempArray;
};
